import { render, staticRenderFns } from "./NewCarousel.vue?vue&type=template&id=df6de3cc&"
import script from "./NewCarousel.vue?vue&type=script&lang=js&"
export * from "./NewCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports